import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "2",
      d: "M6.667 5.834 2.5 10m0 0 4.167 4.167M2.5 10h10M10 5.834c0-.247 0-.37.01-.476a2.5 2.5 0 0 1 2.002-2.239c.105-.02.228-.034.473-.061l.85-.095c1.28-.142 1.919-.213 2.427-.05a2.5 2.5 0 0 1 1.52 1.36c.218.487.218 1.13.218 2.417v6.62c0 1.287 0 1.93-.218 2.417a2.5 2.5 0 0 1-1.52 1.361c-.508.163-1.147.092-2.426-.05l-.851-.095c-.245-.027-.367-.04-.473-.062a2.5 2.5 0 0 1-2.003-2.238c-.009-.107-.009-.23-.009-.476"
    }, null, -1)
  ])))
}
export default { render: render }